<script setup lang="ts">
import Icon from "@/components/generic/Icon/Icon.component.vue";
import { IconName, IconSize } from "@/types";

interface Props {
  iconName: IconName;
  title: string;
  description: string;
}

defineProps<Props>();
</script>

<template>
  <div class="error-message">
    <div class="error-message--title">
      <Icon :icon="iconName" :size="IconSize.Tiny" />
      {{ title }}
    </div>
    <p>{{ description }}</p>
    <slot name="action" />
  </div>
</template>

<style>
.error-message {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-16);
  margin-block: calc(-1 * var(--spacing-24)) var(--spacing-24);
  padding: var(--spacing-24);
  background-color: var(--color-background-warning-shaded);
}

.error-message--title {
  display: flex;
  align-items: center;
  gap: var(--spacing-8);
  font-weight: 700;
}

@media (--small-viewport), (--medium-viewport) {
  .error-message {
    /* Unset surrounding margins and paddings */
    margin-inline: calc(-1 * var(--boundary-box-padding));
  }
}
</style>
